import { storeToRefs } from "pinia"
import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"
import { WorkspaceAudienceGroup } from "@/workspace/models/workspace-audience-group.model"
import type { IWorkspaceAudienceGroup } from "@/workspace/interfaces/api/workspace-audience-group.interface"
import { WorkspaceAudienceGroupRepository } from "@/workspace/repositories/workspace-audience-group-repository"
import { useWorkspaceStore } from "@/workspace/store/workspace.store"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"
import type { IRepositoryRequestConfig } from "@/interfaces/repository/repository-request-config.interface"

export class WorkspaceAudienceGroupController extends GenericModelController<
  WorkspaceAudienceGroup,
  IWorkspaceAudienceGroup,
  WorkspaceAudienceGroupRepository
> {
  constructor() {
    const workspaceStore = useWorkspaceStore()
    const { audienceGroups } = storeToRefs(workspaceStore)

    super(
      WorkspaceAudienceGroup,
      { collection: audienceGroups },
      new WorkspaceAudienceGroupRepository()
    )

    this.socketSynchronizationHandlers = useSocketSynchronizationHandlers(
      WorkspaceAudienceGroup,
      audienceGroups
    )
  }

  public async archive(
    group: WorkspaceAudienceGroup,
    requestConfig?: IRepositoryRequestConfig
  ): Promise<WorkspaceAudienceGroup | undefined> {
    const response = await this.apiFunctions.getRepository().archive(group.id, requestConfig)
    if (response.status !== 200 || !response.data?.id) return undefined
    return this.storeFunctions.updateModel(response.data)
  }
}
